import React from "react";
import { Link } from "react-router-dom";
import "./footer.scss";

const Footer = (props) => (
    <div id="footer">
        <div className="container">
            <div className="row">
                <div className="col-md-8">
                    <p className="footer__copyright">
                        &copy; {(new Date().getFullYear())} Stiebing Immobilien und Baumanagement GmbH | Webprogrammierung <a
                        href="http://www.sebastiangehr.de" target="_blank" rel="noopener noreferrer">Sebastian Gehr</a>
                    </p>
                </div>
                <div className="col-md-4">
                    <div className="footer__links">
                        <Link to="/impressum">Impressum</Link>
                        <Link to="/datenschutz">Datenschutz</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/footer/footer.js